import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import type { ReactNode } from 'react';
import TitleSeparator from '../TitleSeparator';
interface Props {
  children: ReactNode;
}
export default function Recommended(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TitleSeparator sx={{
      mt: 2
    }}>{translate("support.global.faq.title")}</TitleSeparator>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div>{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}